import { toTitleCase } from '../../util/strings';

export const formatSupercategory = (supercategory: string) =>
    toTitleCase(supercategory).replace(' ', ' & ');
